"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TDObjectCoder = exports.TDObjectCoderOption = exports.ObjectCoderContext = void 0;
var TDNode_1 = require("../TDNode");
var TreeDoc_1 = require("../TreeDoc");
var CustomCoder_1 = require("./CustomCoder");
var StringUtil_1 = require("../core/StringUtil");
var __1 = require("..");
var ObjectCoderContext = /** @class */ (function () {
    function ObjectCoderContext() {
        this.nextId = 1;
        /** only used for encoding */
        this.objNodeMap = new Map();
        /** only used for decoding */
        this.idToObjMap = new Map();
        this.path = [];
    }
    return ObjectCoderContext;
}());
exports.ObjectCoderContext = ObjectCoderContext;
var TDObjectCoderOption = /** @class */ (function () {
    function TDObjectCoderOption() {
        this.coders = [CustomCoder_1.CustomCoder.get()];
        this.showType = false;
        this.showFunction = false;
    }
    TDObjectCoderOption.prototype.setShowType = function (showType) {
        this.showType = showType;
        return this;
    };
    TDObjectCoderOption.prototype.setShowFunction = function (showFunction) {
        this.showFunction = showFunction;
        return this;
    };
    return TDObjectCoderOption;
}());
exports.TDObjectCoderOption = TDObjectCoderOption;
/** Javascript specific class that map JS object to/from TDNode */
var TDObjectCoder = /** @class */ (function () {
    function TDObjectCoder() {
        this.KEY_ID = '$id';
        this.KEY_REF = '$ref';
        this.KEY_TYPE = '$type';
    }
    TDObjectCoder.get = function () {
        return TDObjectCoder.it;
    };
    TDObjectCoder.encode = function (obj, opt, target, ctx) {
        if (opt === void 0) { opt = {}; }
        if (target === void 0) { target = new TreeDoc_1.TreeDoc().root; }
        if (ctx === void 0) { ctx = new ObjectCoderContext(); }
        return TDObjectCoder.get().encode(obj, opt, target, ctx);
    };
    TDObjectCoder.prototype.encode = function (obj, option, target, ctx) {
        if (option === void 0) { option = {}; }
        if (target === void 0) { target = new TreeDoc_1.TreeDoc().root; }
        if (ctx === void 0) { ctx = new ObjectCoderContext(); }
        var opt = __1.LangUtil.mergeDeep(new TDObjectCoderOption(), option);
        if (this.isNullOrUndefined(obj))
            return target;
        if (this.isPrimitive(obj))
            return target.setValue(obj);
        if (typeof obj === 'function')
            return target.setValue(opt.showFunction ? obj.toString() : null);
        for (var _i = 0, _a = opt.coders; _i < _a.length; _i++) {
            var coder = _a[_i];
            if (coder.encode(obj, opt, target, ctx))
                return target;
        }
        var idx = ctx.path.indexOf(obj);
        if (idx >= 0)
            return this.setRef(target, StringUtil_1.StringUtil.repeat('../', ctx.path.length - idx));
        var existNode = ctx.objNodeMap.get(obj);
        if (existNode) {
            if (existNode.type === TDNode_1.TDNodeType.MAP) {
                if (!existNode.getChild(this.KEY_ID)) {
                    var id = ctx.nextId++;
                    existNode.createChild(this.KEY_ID).setValue(id);
                    target.doc.idMap[id] = existNode;
                }
                return this.setRef(target, '#' + existNode.getChildValue(this.KEY_ID));
            }
            else
                return this.setRef(target, existNode.pathAsString);
        }
        ctx.path.push(obj);
        ctx.objNodeMap.set(obj, target);
        if (this.isArrayLikeObject(obj)) {
            target.type = TDNode_1.TDNodeType.ARRAY;
            // tslint:disable-next-line: prefer-for-of
            for (var i = 0; i < obj.length; i++)
                this.encode(obj[i], opt, target.createChild(), ctx);
        }
        else {
            // Object or Map
            target.type = TDNode_1.TDNodeType.MAP;
            if (opt.showType && obj.constructor && obj.constructor.name !== 'Object')
                target.createChild(this.KEY_TYPE).setValue(obj.constructor.name);
            for (var _b = 0, _c = Object.keys(obj); _b < _c.length; _b++) {
                var k = _c[_b];
                if (k.startsWith("$$tdNode"))
                    continue;
                if (this.isNullOrUndefined(obj[k]))
                    continue;
                if (!opt.showFunction && typeof obj === 'function')
                    continue;
                this.encode(obj[k], opt, target.createChild(k), ctx);
            }
        }
        ctx.path.pop();
        return target;
    };
    TDObjectCoder.prototype.setRef = function (node, ref) {
        node
            .setType(TDNode_1.TDNodeType.MAP)
            .createChild(this.KEY_REF)
            .setValue(ref);
        return node;
    };
    // Utilities methods
    TDObjectCoder.prototype.isNullOrUndefined = function (obj) {
        return obj === null || obj === undefined || typeof obj === 'symbol';
    };
    TDObjectCoder.prototype.isPrimitive = function (obj) {
        var type = typeof obj;
        if (obj === null || obj === undefined || type !== 'object' && type !== 'function')
            return true;
        var cstr = obj.constructor && obj.constructor.name;
        return cstr === 'Number' || cstr === 'String' || cstr === 'Boolean';
    };
    TDObjectCoder.prototype.isArrayLikeObject = function (obj) {
        return !this.isPrimitive(obj) && this.isLength(obj.length);
    };
    TDObjectCoder.prototype.isLength = function (value) {
        return typeof value === 'number' && value > -1 && value % 1 === 0 && value <= Number.MAX_SAFE_INTEGER;
    };
    TDObjectCoder.it = new TDObjectCoder();
    return TDObjectCoder;
}());
exports.TDObjectCoder = TDObjectCoder;
//# sourceMappingURL=TDObjectCoder.js.map